import { useQuery } from 'react-query';
import { periods } from 'const';

export default ({ period = periods.active, healthcareServiceId = undefined, providerAccountId }) => {
  const { data, isLoading, isSuccess } = useQuery(
    [
      'GET',
      `/apis/v2/appointments`,
      { per: 10, period, healthcareServiceIds: healthcareServiceId ? [healthcareServiceId] : undefined, accountIds: providerAccountId ? [providerAccountId] : undefined },
    ],
    {
      refetchOnMount: period === periods.active,
    },
  );
  return { data: data?.data ?? [], isLoading, isFetching: isLoading, total: data?.data?.meta?.total, isSuccess };
};
